import { toast } from '@skillarea/lib-frontend';
import { IBaseArrayResultDto } from '@skillarea/lib-shared';

export const errorToastInterceptor = (response: IBaseArrayResultDto) => {
  if (response.error) toast?.error(response.error);
};
